import React, { useState, useEffect } from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import { Container } from 'react-bootstrap'

// includes
import MainTable from './includes/SectionTable/MainTable'
import TableTopBar from './includes/SectionTable/TableTopBar'

// toast
import { toast } from 'react-toastify'

// helpers
import useQueryHook from 'utlis/CustomHooks/useQueryHook'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions'

// pagination
import Pagination from 'components/CommonComponents/Pagination'

// apis
import { getSliders_API, cancelGetSlidersApi, deleteSlider_API } from 'utlis/Apis/Sliders_API'

// messages
import { 
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED
} from 'utlis/AppMessages/AppMessages'

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon'

function Sliders(props) {
    // props
    const { 
        setGlobalLoading,
        authState,
        history
    } = props

    // consts
    const loadingCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    const query = useQueryHook();
    const page = query.get('page')
    const keyword = query.get('keyword')

    // store url
    const [storeUrl] = useStoreUrl()

    // states
    const [tableData, setTableData] = useState([])
    const [dataLoading, setDataLoading] = useState(false)

    const [searchQuery, setSearchQuery] = useState("")
    const [paginationLinks, setPaginationLinks] = useState([])

    const [allCheckboxSelected, setAllCheckboxesSelected] = useState(false)
    
    const [tableColumnsVisibility, setTableColumnsVisibility] = useState([
        {
            columnName: 'column_image',
            visible: true
        },
        {
            columnName: 'column_link',
            visible: true
        },
        {
            columnName: 'column_caption',
            visible: true
        },
    ])

    useEffect(() => {
        // loading
        setDataLoading(true)

        // fetching data
        let requestQuery = `${(keyword) ? "keyword=" + keyword + "&" : ""}${page ? "page=" + page : ""}`
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getSliders_API(headers, requestQuery).then(res => {
            const resData = res.data
            console.log("resData ", resData);

            // scroll the page to the top
            window.scrollTo(0, 0)

            // on success
            if (resData && resData.success) {
                setPaginationLinks(resData.links)
                setTableData(resData.data)
            }

            // on error
            if (resData && resData.error) {
                // dismissing all the other toasts
                toast.dismiss();

                // showing toast message
                toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                    autoClose: 3000
                })
            }

            // loading
            setDataLoading(false)
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getSliders_API `, err.message)

            // dismissing all the other toasts
            toast.dismiss();

            // showing toast message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // loading
                    setDataLoading(false)
                }
            })
        })

        return () => {
            cancelGetSlidersApi && cancelGetSlidersApi()
        }
    },[
        keyword,
        page,
        authState.apiToken, 
        authState.commonToken
    ])

    // manage search result
    const handleSearchChange = debounce(ev => {
        let searchQueryValue = ev.target.value
        if (searchQueryValue?.length) {
            setSearchQuery(searchQueryValue)
            history.push(`${storeUrl}/catalog/sliders?keyword=${searchQueryValue}&page=1`)
        }

        if (!searchQueryValue) {
            setSearchQuery("")
            history.push(`${storeUrl}/catalog/sliders?page=1`)
        }
    }, 500)

    // handle select all
    const handleSelectAllChange = ev => {
        const checkboxes = document.getElementsByClassName('all-checkboxes-selector-checkbox')

        setAllCheckboxesSelected(!allCheckboxSelected) // setting checkbox values

        setTimeout(() => {
            if (ev.target.checked) {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = true
                })
            } else {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = false
                })
            }
        }, 50)
    }

    // delete slider
    const handleDelete = (ev, itemId) => {
        ev.preventDefault()

        if(itemId) {
            var confirmation = window.confirm("Are you sure you want to delete the slider?")

            if(confirmation) {
                // loading
                setGlobalLoading(true)
    
                // fetching data
                const headers = {
                    "Authorization": `Bearer ${authState.commonToken}`,
                    "Api-Token": authState.apiToken,
                    "Access-Token": "",
                    // "Store-Id": authState.storeId,
                }
                deleteSlider_API(headers, itemId).then(res => {
                    const resData = res.data
                    console.log("resData ", resData);
    
                    // on success
                    if (resData?.success) {
                        // updating blogs state after deleting an blog.
                        const filteredData = tableData.filter(item => item.slider_id !== itemId)

                        // settings updated blogs
                        setTableData(filteredData)

                        // dismissing all the other toasts
                        toast.dismiss();
    
                        // showing toast message
                        toast.success("Slider deleted successfully", {
                            autoClose: 3000,
                            onClose: () => {}
                        }) 
                    }
    
                    // on error
                    if (resData && resData.error) {
                        // dismissing all the other toasts
                        toast.dismiss();
    
                        // showing toast message
                        toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                            autoClose: 3000
                        })
                    }
    
                    // loading
                    setGlobalLoading(false)
                }).catch(err => {
                    console.log(`${ERROR_WHILE__NAME} deleteSlider_API `, err.message)
        
                    // dismissing all the other toasts
                    toast.dismiss();
        
                    // showing toast message
                    toast.error(UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500,
                        onClose: () => {
                            // loading
                            setGlobalLoading(false)
                        }
                    })
                })
            }
        }
    }

    // table columns visibility
    const handleTableColumnsVisibility = (ev, columnName) => {
        const isChecked = ev.target.checked

        if(columnName) {
            const updatedList = tableColumnsVisibility.map(item => {
                if(item.columnName === `column_${columnName}`) {
                    return {
                        ...item,
                        visible: isChecked
                    }
                }
                return item
            })

            setTableColumnsVisibility(updatedList) // updating list
        }
    }
    

    return (
        <section id="app-sliders" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-sliders">
                    {/* heading */}
                    <div className="app-header-wrapper d-flex mb-2">
                        <p className="app-heading text-capitalize">Sliders</p>
                    </div>

                    {/* content */}
                    <div className="app-content-container">
                        <div className="app-card">
                            <div className="app-card-content bg-white border st-border-light st-default-rounded-block mb-3">
                                {/* top bar */}
                                <div className="acc_top-bar border-bottom st-border-light">
                                    <TableTopBar
                                        tableColumnsVisibility={tableColumnsVisibility}
                                        handleTableColumnsVisibility={(ev, columnName) => handleTableColumnsVisibility(ev, columnName)}

                                        history={history}

                                        handleSearchChange={handleSearchChange}
                                    />
                                </div>

                                {/* table */}
                                <div className="st-listing-table sliders-table">
                                    <MainTable
                                        tableColumnsVisibility={tableColumnsVisibility}

                                        allCheckboxSelected={allCheckboxSelected}
                                        handleSelectAllChange={handleSelectAllChange}
                                        
                                        loading={dataLoading}
                                        loadingCount={loadingCount}
                                        tableData={tableData}

                                        handleDelete={handleDelete}
                                    />
                                </div>
                            </div>

                            {/* paginations */}
                            <div className="pagination-container d-flex justify-content-end">
                                <Pagination
                                    searchQuery={searchQuery}
                                    routeName={storeUrl + "/catalog/sliders"}
                                    paginationLinks={paginationLinks}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </Container>        
        </section>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(Sliders)